import { useEffect, useRef, useState } from 'react';

import { getEstimateInformationQuery } from '@widgets/EstimateInformation/api/hooks/getEstimateInformationQuery';

export const useHiddenEstimatesCount = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [hiddenCount, setHiddenCount] = useState(0);
    const { data } = getEstimateInformationQuery();

    useEffect(() => {
        const update = () => {
            const wrapper = wrapperRef.current;
            if (!wrapper) return;

            const containerRect = wrapper.getBoundingClientRect();
            const links = wrapper.querySelectorAll('a');

            let visible = 0;

            for (const link of links) {
                const linkRect = link.getBoundingClientRect();

                const isVisible =
                    linkRect.right > containerRect.left && linkRect.left < containerRect.right;

                if (isVisible) {
                    visible++;
                } else {
                    break;
                }
            }

            setHiddenCount(links.length - visible);
        };

        const resizeObserver = new ResizeObserver(update);
        if (wrapperRef.current) {
            resizeObserver.observe(wrapperRef.current);
        }

        window.addEventListener('resize', update);
        update();

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', update);
        };
    }, [data]);

    return { wrapperRef, hiddenCount };
};
